// Autogenerated search index for site sections.
// This can be extended dynamically (e.g., pulling product data or applicator cities)
// Data shape kept simple for client-side fuzzy matching.

export interface SearchIndexItem {
  id: string; // unique id
  title: string; // display title
  url: string; // target href (may include #anchor)
  description?: string; // short blurb
  tags?: string[]; // keywords to improve matching
  group?: string; // logical grouping (Home, About, Product, Reviews, Applicators)
  hideByDefault?: boolean; // if true, only show when query matches directly
}

// Helper to build anchors consistently
const page = (
  group: string,
  title: string,
  url: string,
  description: string,
  tags: string[] = [],
  opts: { hideByDefault?: boolean } = {},
): SearchIndexItem => ({
  id: `${group.toLowerCase()}-${
    url.split("#")[1] || url.replace(/\//g, "-")
  }`.replace(/--+/g, "-"),
  title,
  url,
  description,
  tags,
  group,
  hideByDefault: opts.hideByDefault,
});

// High-level entries only; granular section anchors removed for concise search.
const coreEntries: SearchIndexItem[] = [
  page(
    "Site",
    "Courses",
    "/courses",
    "Plaster applicator courses and pro video training",
    ["courses", "training", "videos", "plaster", "applicator"],
  ),
  page(
    "Site",
    "Pricing",
    "/pricing",
    "Featured listing plans for the contractor directory",
    ["pricing", "plans", "featured", "directory", "contractors"],
  ),
  page("Site", "Reviews", "/reviews", "Customer reviews and ratings", [
    "reviews",
    "ratings",
  ]),
  page(
    "Site",
    "Contractor Directory",
    "/applicators",
    "Browse the plaster contractor directory",
    ["applicators", "contractors", "directory", "plaster"],
  ),
  page("Site", "About", "/about", "Company story, values, and team", [
    "about",
    "company",
    "team",
  ]),
  page(
    "Site",
    "Team",
    "/about#about-team",
    "Leadership team profiles",
    ["team", "leadership"],
    { hideByDefault: true },
  ),
  page(
    "Site",
    "Contact Us",
    "/contact",
    "Get in touch with The Plaster People",
    ["contact", "support", "help"],
  ),
  page("Site", "Home", "/", "Homepage", ["home", "landing"], {
    hideByDefault: true,
  }),
];

// Dynamic city entries for applicators
import { applicatorsByCity } from "@/data";
const cityEntries: SearchIndexItem[] = Object.keys(applicatorsByCity)
  .sort()
  .map((city) =>
    page(
      "City",
      `${city} Applicators`,
      `/applicators/${city.toLowerCase().replace(/\s+/g, "-")}`,
      `Plaster contractors and applicators in ${city}`,
      ["applicators", city, "contractors", "plaster"],
      { hideByDefault: false },
    ),
  );

export const searchIndex: SearchIndexItem[] = [...coreEntries, ...cityEntries];
